// component
import Iconify from '../../components/Iconify';
import Label from '../../components/Label';

// routes
import { PATH_DASHBOARD } from '../../routes/paths';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

// Retrieve data from localStorage
const data = localStorage.getItem('bagde_count_chats');

const navConfig = [
	{
		subheader: 'main',
		items: [
			{
				title: 'dashboard',
				path: PATH_DASHBOARD.main.app,
				icon: getIcon('material-symbols:dashboard'),
			},
			{
				title: 'forums',
				path: PATH_DASHBOARD.main.forum,
				icon: getIcon('ic:round-view-timeline'),
			},
			{
				title: 'chats',
				path: PATH_DASHBOARD.main.chats,
				// info: <Label color="error">{data}</Label>,
				icon: getIcon('ph:chats-fill'),
			},
			{
				title: 'announcement',
				path: PATH_DASHBOARD.main.announcement,
				icon: getIcon('mdi:announcement'),
			},
			{
				title: 'events',
				path: PATH_DASHBOARD.main.events,
				icon: getIcon('mdi:events'),
			},
		],
	},
	{
		subheader: 'management',
		items: [
			{
				title: 'profiling',
				path: PATH_DASHBOARD.profiling.create,
				icon: getIcon('mdi:text-box-edit'),
			},
			{
				title: 'members',
				path: PATH_DASHBOARD.members.root,
				icon: getIcon('mdi:users-group'),
				children: [
					{ title: 'verified', path: PATH_DASHBOARD.members.list },
					{
						title: 'unverified',
						path: PATH_DASHBOARD.members.unverified,
						// info: <Label color="error">1</Label>,
					},
				],
			},
		],
	},
	{
		subheader: 'controls',
		items: [
			{
				title: 'analytics',
				path: PATH_DASHBOARD.analytics.root,
				icon: getIcon('eva:pie-chart-2-fill'),
				children: [
					{ title: 'disability', path: PATH_DASHBOARD.analytics.disability },
					{ title: 'district', path: PATH_DASHBOARD.analytics.district },
					// { title: 'donation', path: PATH_DASHBOARD.analytics.donation },
					{ title: 'assistance', path: PATH_DASHBOARD.analytics.assistance },
					{ title: 'static', path: PATH_DASHBOARD.analytics.summary },
				],
			},
			// {
			// 	title: 'mapping',
			// 	path: PATH_DASHBOARD.mapping.main,
			// 	icon: getIcon('material-symbols:map'),
			// },
			{
				title: 'requests',
				path: PATH_DASHBOARD.request.root,
				icon: getIcon('mdi:donation-outline'),
				children: [
					{ title: 'approved', path: PATH_DASHBOARD.request.approved },
					{ title: 'pending', path: PATH_DASHBOARD.request.pending },
					{ title: 'disapproved', path: PATH_DASHBOARD.request.disapproved },
					// { title: 'enlisted', path: PATH_DASHBOARD.request.enlisted },
				],
			},
			{
				title: 'assistive device',
				path: PATH_DASHBOARD.assistive.root,
				icon: getIcon('tabler:wheelchair'),
				children: [
					{ title: 'add new', path: PATH_DASHBOARD.assistive.create },
					{ title: 'stocks', path: PATH_DASHBOARD.assistive.list },
					{ title: 'logs', path: PATH_DASHBOARD.assistive.logs },
				],
			},
		],
	},

	// {
	// 	title: 'user',
	// 	path: '/dashboard/user',
	// 	icon: getIcon('eva:people-fill'),
	// },
	// {
	//   title: 'product',
	//   path: '/dashboard/products',
	//   icon: getIcon('eva:shopping-bag-fill'),
	// },
	// {
	//   title: 'blog',
	//   path: '/dashboard/blog',
	//   icon: getIcon('eva:file-text-fill'),
	// },
	// {
	//   title: 'login',
	//   path: '/login',
	//   icon: getIcon('eva:lock-fill'),
	// },
	// {
	//   title: 'register',
	//   path: '/register',
	//   icon: getIcon('eva:person-add-fill'),
	// },
	// {
	//   title: 'Not found',
	//   path: '/404',
	//   icon: getIcon('eva:alert-triangle-fill'),
	// },
];

export default navConfig;
